import { Dispatcher } from "../../flux";

const enableInstantHighlights = () => {
  Dispatcher.emit(
    Dispatcher.SET_FAST_HIGHLIGHTER,
    Fraction.Helpers.isLabEnabled("instant-highlights"),
    "instant-highlights"
  );
};

module.exports = {
  metadata: () => {
    return {
      id: "instant-highlights",
      name: i18n.t("instant-highlights.instant-highlights"),
      description: i18n.t("instant-highlights.description"),
      toggle: enableInstantHighlights,
      starLab: true,
      lab: "graduate",
      type: "extension"
    };
  }
};
